import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#1F2937",
      "fill-rule": "evenodd",
      class: "dark:fill-white",
      "clip-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M8.517 1.834a4 4 0 0 1 5.656 5.656l-.008.008-2 2a4 4 0 0 1-6.032-.432.667.667 0 0 1 1.068-.799 2.667 2.667 0 0 0 4.02.288l1.997-1.995a2.667 2.667 0 0 0-3.772-3.77L8.303 3.926a.667.667 0 1 1-.94-.945L8.51 1.84z" }),
      _createElementVNode("path", { d: "M5.266 5.582a4 4 0 0 1 4.601 1.352.667.667 0 1 1-1.068.799 2.667 2.667 0 0 0-4.02-.288L2.781 9.44a2.667 2.667 0 0 0 3.77 3.77l1.137-1.135a.667.667 0 0 1 .942.943l-1.14 1.14-.008.008A4 4 0 0 1 1.827 8.51l.008-.008 2-2a4 4 0 0 1 1.431-.92" })
    ], -1)
  ]))]))
}
export default { render: render }